export const USER_STATISTICS = {
  GET_TODAY_STATISTICS_REQUEST: "GET_TODAY_STATISTICS_REQUEST",
  GET_TODAY_STATISTICS_SUCCESS: "GET_TODAY_STATISTICS_SUCCESS",
  GET_TODAY_STATISTICS_FAILURE: "GET_TODAY_STATISTICS_FAILURE",
  CLEAR_STATISTICS: "CLEAR_STATISTICS",
};

const initState = {
  today: null,
  overall: null,
  walletType: null,
  loading: false,
  error: null,
};

const userStatisticsReducer = (state = initState, action) => {
  switch (action.type) {
    case USER_STATISTICS.GET_TODAY_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case USER_STATISTICS.GET_TODAY_STATISTICS_SUCCESS:
      return {
        ...state,
        today: action.payload?.today ?? null,
        walletType: action.payload?.wallet_type ?? null,
        loading: false,
        error: null,
      };

    case USER_STATISTICS.GET_TODAY_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case USER_STATISTICS.CLEAR_STATISTICS:
      return initState;

    default:
      return state;
  }
};

export default userStatisticsReducer;
